// extracted by mini-css-extract-plugin
export default {"container":"ClanSupply_container_a288a","innerShadow":"ClanSupply_innerShadow_deabc"};